import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { CustomerSettingsSchema, DEFAULT_CUSTOMER_TYPES, paths } from "@clevis/shared-types";
import { db } from "../lib/firebase";

/** The company's customer types (Customers → "Customer types…"); the defaults until the owner edits them. */
export function useCustomerTypes(tenantId: string | null): string[] {
  const [types, setTypes] = useState<string[]>(DEFAULT_CUSTOMER_TYPES);
  useEffect(() => {
    if (!tenantId) return;
    return onSnapshot(
      doc(db, paths.tenantCustomerSettings(tenantId)),
      (snap) => setTypes(CustomerSettingsSchema.parse(snap.data() ?? {}).types),
      () => undefined,
    );
  }, [tenantId]);
  return types;
}
